// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";

import { useToaster } from "@insite/mobius/Toast/ToasterContext";
import Typography from "@insite/mobius/Typography";
import { isServiceHistoryInvoiceModel } from "@store/Framework/Common/Hooks/useReportAPI/ReportApiReportHandlers";

import getColor from "@insite/mobius/utilities/getColor";
import useReportApi from "@store/Framework/Common/Hooks/useReportAPI/useReportAPI";
import {
    ServiceHistoryInvoiceModel,
    ServiceHistoryItemModel,
} from "@store/Framework/Services/Reporting/ReportingModels";
import ApiDataModal from "@store/Library/Components/Reporting/Common/ApiDataModal";
import ServiceHistoryModelMainContent from "@store/Library/Components/Reporting/ServiceHistoryModal/ServiceHistoryModalMainContent";
import ServiceHistorySubHeaders from "@store/Library/Components/Reporting/ServiceHistoryModal/ServiceHistorySubHeader";
import React, { useState } from "react";
import styled, { css } from "styled-components";

export const ModalHeader = styled.div`
    && {
        width: 100%;
        display: flex;
        align-items: center;
        margin-left: 1.25rem;
        & h4 {
            margin: 0 2rem 0 0 !important;
        }
        & button {
            margin-left: 2rem;
            margin-right: 2rem;
        }
    }
`;
export const ModalTitle = styled.div`
    width: 100%;
    display: inline-flex;
    margin: 0 2rem;
    background-color: ${getColor("text.titleTextLightGray")};
    border-radius: 0.5rem;
    padding: 0.5rem 1rem;
    margin-bottom: 1.25rem;
    align-items: center;
    justify-content: space-between;
    & p {
        margin-bottom: 0;
    }
`;

interface Props {
    serviceHistory: ServiceHistoryItemModel;
}
const ServiceHistoryModal: React.FC<Props> = ({ serviceHistory }) => {
    const { isLoading, updateData } = useReportApi("serviceHistoryInvoice");
    const { invoiceNumber, invoiceAmount } = serviceHistory;
    const [serviceHistoryInvoice, setServiceHistoryInvoice] = useState<ServiceHistoryInvoiceModel>();
    const toast = useToaster();
    const toggleModalServiceHistory = async () => {
        const serviceHistoryReturn = await updateData({
            invoiceNum: invoiceNumber,
        });
        if (isServiceHistoryInvoiceModel(serviceHistoryReturn)) {
            setServiceHistoryInvoice(serviceHistoryReturn);
            return true;
        }
        toast.addToast({
            body: translate("No invoice items found"),
            messageType: "warning",
        });
        return false;
    };

    let modalTitle = "";
    if (serviceHistoryInvoice) {
        const {
            soldToAddr1,
            soldToAddr2,
            soldToAddr3,
            soldToAddr4,
            shipToAddr1,
            shipToAddr2,
            shipToAddr3,
            shipToAddr4,
        } = serviceHistoryInvoice;
        modalTitle = `${translate(
            "billing",
        )}: ${soldToAddr1} ${soldToAddr2} ${soldToAddr3} ${soldToAddr4}  /  ${translate(
            "shipping",
        )}: ${shipToAddr1} ${shipToAddr2} ${shipToAddr3} ${shipToAddr4}`.toUpperCase();
    }
    const modalHeader = (
        <>
            <ModalHeader>
                <Typography variant="h4">
                    {translate("Invoice")} # {invoiceNumber}
                </Typography>
                <Typography variant="h4">
                    {translate("Total")} $ {invoiceAmount}
                </Typography>
            </ModalHeader>
        </>
    );

    return (
        <>
            <ApiDataModal
                modalHeader={modalHeader}
                isData={!!serviceHistoryInvoice}
                isLoading={isLoading}
                onClick={toggleModalServiceHistory}
            >
                {serviceHistoryInvoice && (
                    <>
                        <GridContainer>
                            <ModalTitle>
                                <Typography variant="p" color="white">
                                    {modalTitle}
                                </Typography>
                            </ModalTitle>

                            <GridItem
                                css={css`
                                    padding-left: 2rem;
                                    margin: 0 2rem 0 0 !important;
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: baseline;
                                `}
                                width={[12, 12, 12, 5, 5]}
                            >
                                <Typography variant="h5">
                                    {translate("Invoice #")} {invoiceNumber}
                                </Typography>
                                <Typography variant="h5">
                                    {translate("Order #")} {serviceHistory.orderNumber}
                                </Typography>
                                <Typography variant="h5">
                                    {translate("PO #")} {serviceHistoryInvoice.purchaseOrder}
                                </Typography>
                            </GridItem>
                            <ServiceHistorySubHeaders serviceHistoryInvoice={serviceHistoryInvoice} />
                            <ServiceHistoryModelMainContent serviceHistoryInvoice={serviceHistoryInvoice} />
                        </GridContainer>
                    </>
                )}
            </ApiDataModal>
        </>
    );
};

export default ServiceHistoryModal;
